import { makeAutoObservable } from "mobx";
import { AttributeShelf } from "../AttributeShelf";

export class LoaderShelf {
	public _loading = new AttributeShelf(false);

	constructor() {
		makeAutoObservable(this);
	}

	public get isLoading(): boolean {
		return this._loading.value;
	}

	public get isLoaded(): boolean {
		return !this._loading.value;
	}

	public tryStart(errorMessage = "Still Loading"): void {
		if (this.isLoading) {
			throw Error(errorMessage);
		}

		this.start();
	}

	public start(): void {
		this._loading.set(true);
	}

	public end(): void {
		this._loading.set(false);
	}
}
